<section id="section06">

    <div class="container">

        <div class="section-header">
            <h2>{{ data.TITULO }}</h2>
            <h4>{{ data.DESCRICAO }}</h4>
        </div>

        <div class="row d-flex justify-content-center">
            <div *ngFor="let modulo of data.MODULOS; let index = index"
                class="col-md-6 col-lg-4 mb-4 d-flex justify-content-center align-items-stretch">
                <div class="card" [routerLink]="[ modulo.URL | localize ]">
                    <div class="card-header d-flex justify-content-center align-items-center">
                        <img src="{{ modulo.IMAGEM.URL }}" alt="{{ modulo.IMAGEM.DESCRICAO }}" width="90px">
                    </div>
                    <div class="card-body">
                        <p class="m-0 mb-2 text-primary font-weight-bold">{{ modulo.TITULO }}</p>
                        <p class="m-0">{{ modulo.DESCRICAO }}</p>
                    </div>
                </div>
            </div>
        </div>

    </div>

</section>